var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),(_vm.$store.state.totens.dialogNewTotem)?_c('NewTotem'):_vm._e(),(_vm.$store.state.totens.dialogEditTotem)?_c('EditTotem'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }